export function courseIdFromRedirect(redirect: string | null | undefined): string {
  const match = String(redirect || '').match(/\/courses\/([a-f0-9-]+)/i);
  return match?.[1] || '';
}

export function buildRegistrationAuthUrl(params: {
  courseId: string;
  slug?: string | null;
  companyId?: string | null;
  mode?: 'signin' | 'signup';
}): string {
  const query = new URLSearchParams({
    redirect: `/courses/${params.courseId}`,
    mode: params.mode || 'signin',
    registrationCourse: params.courseId,
  });
  if (params.slug) query.set('registrationSlug', params.slug);
  if (params.companyId) query.set('companyId', params.companyId);
  return `/login?${query.toString()}`;
}

export function registrationCourseDestination(params: {
  enrolledCourseIds?: string[] | null;
  enrolledCourseId?: string | null;
  fallbackCourseId?: string | null;
  redirect?: string | null;
}): string {
  const enrolledCourseIds = [...new Set((params.enrolledCourseIds || []).filter(Boolean))];
  if (enrolledCourseIds.length > 1) return '/courses';
  const enrolledCourseId = String(params.enrolledCourseId || params.fallbackCourseId || '').trim();
  if (enrolledCourseId) return `/courses/${enrolledCourseId}`;
  return params.redirect || '/courses';
}
